export default "__VITE_ASSET__b3e71c50__"